module.exports = __webpack_public_path__ + "img/markerDestination.064085a3.svg";